import React from 'react'
import type { CellProps } from 'react-table'
import LinkCell from '../../Generics/GenericLinkCell'
import type { SearchVehicle } from '../types'

/**
 * Link to Vehicle Detail Page.
 * Use `assetId` if no `stockNumber` (DMS feed vehicles)
 */
export const MakeModelYear = ({
    row: {
        original: { stockNumber, assetId },
    },
    cell: { value },
}: CellProps<SearchVehicle>): React.ReactNode => (
    <LinkCell href={Number(stockNumber) ? `/details/vehicles?sn=${stockNumber}` : `/details/vehicles?id=${assetId}`}>
        {value}
    </LinkCell>
)
